import { getKeys } from './getKeys'

export const consentTranslations = {
  // ConsentConfirmationCard
  QUESTION: "Ready to confirm the {{nominative}}'s consent?",
  CONFIRM_BUTTON: 'Confirm',
  SIGN_BUTTON: 'Sign',
  CONSENT_STATUS_LABEL: 'Consent status',
  HELPER_TEXT: 'This will count for all consent forms being signed now',

  // Status options
  OPTION_NO_STATUS: 'No status',
  OPTION_SAVE_FORM: 'Save form',
  OPTION_SIGN_FORM: 'Sign form',
  OPTION_CONSENT_NOT_OBTAINED: 'Consent not obtained',
  OPTION_COMPLETED: 'Completed',
  OPTION_PLANNED: 'Planned',
  OPTION_REQUESTED: 'Requested',
  OPTION_SCHEDULED: 'Scheduled',
  OPTION_POSTPONED: 'Postponed',
  OPTION_CANCELLED: 'Cancelled',
  OPTION_WITHDRAWN: 'Withdrawn',
  OPTION_REFUSED: 'Refused',
  OPTION_PROVIDED: 'Provided',

  // Status info text descriptions
  INFO_NO_STATUS: 'A short description will show here based on your selection',
  INFO_CONSENT_NOT_OBTAINED:
    'Informed consent could not be obtained from the individual or their representative. No review needed',
  INFO_COMPLETED:
    'The individual or their representative has given informed consent and the activity is complete',
  INFO_PLANNED: 'The need to get informed consent has been identified.',
  INFO_REQUESTED:
    'Informed consent has been requested from the individual or their representative, but no response has been received yet',
  INFO_SCHEDULED: 'A time has been arranged to request informed consent',
  INFO_POSTPONED:
    'The time to request for informed consent has been delayed',
  INFO_CANCELLED:
    'Request for informed consent was cancelled before asking the individual or their representative. No review needed',
  INFO_WITHDRAWN:
    'After initially giving informed consent, the individual or their representative has withdrawn it. No review needed',
  INFO_REFUSED:
    'The individual or their representative has refused to give informed consent',
  INFO_PROVIDED:
    'The patient or their representative has given informed consent',
  INFO_PENDING: 'Consent is pending',

  // Extra fields
  POSTPONED_LABEL: 'What was the last review date?',
  POSTPONED_HELPER: 'Please enter the last date set for review',
  POSTPONED_PLACEHOLDER: 'DD-MM-YYYY',
  WITHDRAWN_LABEL: 'Give a reason for withdrawal',
  WITHDRAWN_HELPER: 'A reason for withdrawal must be provided',
  WITHDRAWN_PLACEHOLDER: 'Enter reason',

  // Care Plan Linking Confirmation Modal
  CARE_PLAN_LINKING_MODAL_TITLE: 'Consent & Care plan linking confirmation',
  CARE_PLAN_LINKING_MODAL_SUCCESS_MESSAGE:
    'This consent form has been linked successfully to these care plans!',
  CARE_PLAN_LINKING_MODAL_NO_REVIEW_TRIGGERED: 'No review has been triggered.'
}

export const consentConstants = getKeys(consentTranslations)
